import { ContentPageSectionTitle } from "@components/content-page/SectionTitle"
import { FaqQuestion } from "@components/faq-question"
import { Container } from "@components/ui/Container"
import { FC } from "react"
import {
  FaqQuestion as FaqQuestionModel,
  PricingSingleton,
} from "__generated__/sanity"
import chunk from "lodash.chunk"

type PricingPageFaqProps = PricingSingleton["fields"]["faq"] & {
  questions: FaqQuestionModel[]
}

export const PricingPageFaq: FC<PricingPageFaqProps> = ({
  questions,
  title,
  description,
}) => {
  const questionsChunks = chunk(questions, Math.ceil(questions.length / 2))

  return (
    <Container size="small" className="mb-30 md:mb-44 lg:mb-50">
      <ContentPageSectionTitle title={title} description={description} />
      <div className="grid grid-cols-[1fr] md:grid-cols-[1fr_1fr] md:gap-x-6 md:gap-y-0 lg:gap-x-8">
        <div>
          {questionsChunks[0].map((item, key) => (
            <FaqQuestion key={key} {...item} />
          ))}
        </div>
        <div>
          {questionsChunks[1].map((item, key) => (
            <FaqQuestion key={key} {...item} />
          ))}
        </div>
      </div>
    </Container>
  )
}
